
    import {computed, ComputedRef, defineComponent, reactive, watch} from 'vue'
    import {useStore} from "@/store";
    import {useRoute} from "vue-router";
    import componentTitle from './componentTitle.vue';
    import defectList from './defectList.vue';

    interface TitleData {
        text: string;
        icon: string;
        clickFun: string;
    }

    interface State {
        titleText: string;
        titleData: TitleData;
        defectList: object[];
        listName: string;
        listDefectNumber: number;
        importantNumber: number;
        listSumNumber: number;
        reportLevel: number;
    }

    export default defineComponent({
        name: "PowerCheck",
        setup() {
            let state: State = reactive({
                titleText: '动力检测',
                titleData: {
                    text: '标准说明',
                    icon: 'shuoming.png',
                    clickFun: 'showRemind',
                    modelCnt: [
                        '【动力检测标准】如检测项中出现漏油、异响、缸体外部响、缸盖气门响、缸体内部响、故障、冒蓝烟、抖动、渗油、修复痕迹、冒黑烟、油改气、冒白烟、液位高、液位低、变质、破损、老化、漏水、换挡冲击、卡滞、闯挡、拆卸未换、更换、缺失、改装、水温高等缺陷状况，根据《268V检测认证标准》综合判断为动力缺陷。',
                        'prop_up_height',
                        '【受限不可检】检测过程中，受环境、车主授权等不可抗原因导致无法检测，268V不对受限不可检的检测项产生的任何疑问负责。'
                    ]
                },
                defectList: [],
                listName: '动力检测',
                listDefectNumber: 0,
                importantNumber: 0,
                listSumNumber: 0,
                reportLevel: 0,
            })
            const {query} = useRoute();
            state.reportLevel = Number(`${query.reportLevel}`) || 0;
            let store = useStore()
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            watch(dataInfo, (data: any) => {
                const {power} = data;
                if (power) {
                    const {importantItemCount, defectItemCount, itemCount, itemList, itemTitle} = power
                    state.defectList = itemList;
                    state.listName = itemTitle;
                    state.listDefectNumber = defectItemCount;
                    state.importantNumber = importantItemCount;
                    state.listSumNumber = itemCount;
                }
            })
            return {
                state
            }
        },
        components: {
            componentTitle, defectList
        }
    })
